import { toast } from "react-toastify";
import { apiGetOrderReceipt } from "../api/index";
import { openReceiptDialog } from "./receiptDialogBus";

/**
 * Open the order's receipt document for printing, in the same window.
 *
 * The document is the server's signed receipt page (the same one a customer
 * receives), not a print of whatever dashboard page happens to be open: it
 * names the seller and TIN, the customer, the payment and its reference, the
 * lines, VAT where charged, the terms, and the URA markings only when URA
 * issued them.
 *
 * It opens in the one ReceiptPrintDialog mounted in App.js (through
 * utilities/receiptDialogBus.js), so the operator stays on the order they
 * were working on instead of being sent to a new tab for every receipt.
 */
export async function openReceiptForPrint(orderId) {
  if (!orderId) return;
  try {
    const { data } = await apiGetOrderReceipt(orderId);
    if (!data?.ok || !data?.viewUrl) throw new Error(data?.message || "Receipt is not available for this order.");
    openReceiptDialog({ orderId, viewUrl: data.viewUrl });
  } catch (err) {
    toast.error(err?.response?.data?.message || err?.message || "Could not open the receipt.");
  }
}

export default openReceiptForPrint;
